import { UserAccountModel, UserCollectionModel, RoleModel, DataFilter, UserSearchModel, WorkshopUserModel } from "@/core/models";
import { HttpService } from "@/core/services";

export const UserService = {
  getUser(id: number) {
    return HttpService.getData<UserAccountModel>(`users/${id}`);
  },
  getUserWorkshopDetails() {
    return HttpService.getData<WorkshopUserModel>("users/workshop/info");
  },
  postUser(model: UserAccountModel) {
    return HttpService.postModel("users", model);
  },
  putUser(model: UserAccountModel) {
    return HttpService.putModel("users", model);
  },
  getRoles() {
    return HttpService.getData<RoleModel[]>("roles");
  },
  find(dataFilter: DataFilter) {
    return HttpService.find<UserCollectionModel, DataFilter>("users/filter", dataFilter);
  },
  search(search: string) {
    return HttpService.getData<UserSearchModel[]>(`users/${search}/search`);
  },
  searchImiUsersAsync(search: string) {
    return HttpService.getData<UserSearchModel[]>(`users/imi/${search}/search`);
  },
  updateAttendance(id: number, workshopId: number, attended: boolean) {
    return HttpService.put(`users/${id}/workshop/${workshopId}/attended/${attended}`);
  },
  getNoneUser() {
    return {
      userId: undefined,
      fullName: "- none -",
      email: "",
    } as UserSearchModel;
  },
};
